const $ = require( 'jquery' );
window.jQuery = $;
window.$ = $;

require( './vendor/jquery-ui-1.11.4.min' );

require( 'bootstrap' );
require( 'jquery.cookie' );
require( 'slick-carousel' );
require( 'magnific-popup' );
require( 'lightgallery' );
require( 'what-input' );

require( './elements/loader' );
require( './elements/cookies' );
require( './elements/lazyload' );
require( './elements/ceidg' );

import { Navbar } from './elements/navbar.js';
import { SliderManager } from './elements/slider-manager.js';
import { LightGallery } from './elements/light-gallery';
import { Newsletter } from './elements/newsletter';
import { PostsList } from './elements/posts-list';
import { Repertoire } from './elements/repertoire';
import { UserDashboard } from './elements/user-dashboard';
import { Filters } from './elements/filters';
import { Faq } from './elements/faq';

(() => {
    new Navbar();
    new SliderManager();
    new LightGallery();
    new Newsletter();
    new Repertoire();
    new UserDashboard();
    new Filters();
    new Faq();
    new PostsList();
})();

$( document ).ready( function() {
    const popupsWrapper = $( '#popups-wrapper' );

    if ( popupsWrapper.length > 0 ) {
        let popup = $( '.popup' );
        let url = popup.data( 'link' ) ? popup.data( 'link' ) : null;
        let blank = parseInt( popup.data( 'blank' ) ) === 1 ? '_blank' : '_self';
        let markup = '<div class="mfp-figure">' +
            '<div class="mfp-close"></div>' +
            '<div class="mfp-img"></div>' +
            '<div class="mfp-bottom-bar">' +
            '<div class="mfp-title"></div>' +
            '<div class="mfp-counter"></div>' +
            '</div>' +
            '</div>';

        if ( url ) {
            markup = '<div class="mfp-figure">' +
                '<div class="mfp-close"></div>' +
                '<a href="' + url + '" target="' + blank + '">' +
                '<div class="mfp-img"></div>' +
                '</a>' +
                '<div class="mfp-bottom-bar">' +
                '<div class="mfp-title"></div>' +
                '<div class="mfp-counter"></div>' +
                '</div>' +
                '</div>';
        }

        popup.magnificPopup( {
            type: 'image',
            removalDelay: 300,
            mainClass: 'mfp-fade',
            fixedContentPos: true,
            image: {
                verticalFit: true,
                markup: markup
            },
            gallery: {
                enabled: true
            }
        } );
        popup.get( 0 ).click();
    }
} );

if ( window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD ) {
    if ( localStorage.getItem( 'firstStepURL' ) && localStorage.getItem( 'fullCarnetProcess' ) ) {
        window.location.href = localStorage.getItem( 'firstStepURL' );
        localStorage.removeItem( 'fullCarnetProcess' );
        localStorage.removeItem( 'firstStepURL' );
    }
}
